import { render, staticRenderFns } from "./MenuCartPrice.vue?vue&type=template&id=1819fcbc&scoped=true&"
import script from "./MenuCartPrice.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuCartPrice.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuCartPrice.vue?vue&type=style&index=0&id=1819fcbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1819fcbc",
  null
  
)

export default component.exports